import { colors, safeSpacing } from "@/utils/const";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useMemo } from "react";
import OutImgSection from "../out-img-section";
import { useRouter } from "next/router";
import CustomText from "../text";
import ListAccordion from "../list-accordion";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export default function ListSection({
  img,
  altImg,
  title,
  titleType,
  list,
  reverse,
  imgReverse,
}) {
  const router = useRouter();
  const { locale } = router;
  const isArabic = locale === "ar";

  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "xl"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));

  const horizontal = (() => {
    if (isXs) return safeSpacing.horizontal.xs;
    if (isSm) return safeSpacing.horizontal.sm;
    if (isMd) return safeSpacing.horizontal.md;
    if (isLg) return safeSpacing.horizontal.lg;
    if (isXl) return safeSpacing.horizontal.xl;
    return safeSpacing.horizontal;
  })();
  const normalizedList = useMemo(() => {
    if (!Array.isArray(list)) return [];

    return list.map((item, index) => {
      const q = item?.q ?? item?.title?.text?.[locale] ?? "";

      const a = item?.a ?? item?.desc?.text?.[locale] ?? "";

      return {
        ...item,
        id: item?.id ?? index,
        q,
        a,
        titleType: item?.title?.type,
        descType: item?.desc?.type,
      };
    });
  }, [list, locale]);
  return (
    <Box
      data-aos={"fade-down"}
      data-aos-delay={"500"}
      sx={{ bgcolor: colors.navy, overflowX: "hidden" }}
    >
      <Box
        component="section"
        className="horizontal-safe-padding vertical-safe-padding"
        sx={{ overflow: "hidden" }}
      >
        <Grid
          container
          spacing={{ xs: 4, md: 2, xl: 8 }}
          alignItems="center"
          sx={{
            flexDirection: {
              // xs: "column-reverse",
              xs: "column",
              md: reverse ? "row-reverse" : "row",
            },
          }}
        >
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              position: "relative",
              display: "flex",
              order: { xs: 1, md: imgReverse ? 2 : 1 },
              justifyContent: {
                xs: "center",
                md: !isArabic ? "flex-start" : "flex-end",
              },
              // pl: 0 ,
            }}
          >
            <OutImgSection
              img={img}
              altImg={altImg}
              customStyle={{
                width: "100%",
                ...(isArabic
                  ? {
                      marginRight: {
                        xs: 0,
                        md: imgReverse ? `${horizontal}px` : 0,
                      },
                    }
                  : {
                      marginLeft: {
                        xs: 0,
                        md: imgReverse ? `${horizontal}px` : 0,
                      },
                    }),
                zIndex: 1,
                transform: {
                  lg: isArabic ? "translateX(15%)" : "translateX(-20%)",
                  xl: isArabic ? "translateX(0%)" : "translateX(0%)",
                },
              }}
              side={isArabic ? "right" : "left"}
              imgReverse={imgReverse}
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={8}
            sx={{
              order: { xs: 2, md: imgReverse ? 1 : 2 },
            }}
          >
            <CustomText
              text={title}
              type="xl"
              customStyle={{
                color: colors.dark_yellow,
                fontWeight: "700",
                lineHeight: 1,
              }}
              variant={titleType}
            />
            <ListAccordion items={normalizedList} renderHTML={true} withBg />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
